/**
 * <Email
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import validator from 'validator';

export function validateEmail(value) {

  if(value && !validator.isEmail(value.trim())){
    return {
      ok: false,
      failed: {
        because: ['invalid_email'],
        value
      }
    }
  }
}

class Email extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
  }

  render() {
    const {
      value,
      placeholder,
      onChange,
    } = this.props;

    return (<input type='email' value={value} className='form-control' placeholder={placeholder} onChange={(e)=>{ onChange(e.target.value); }} />);
  }
}

export default Email;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/Email/index.js